/**
 * Condiciones de despacho vigentes y el hook para leerlas.
 *
 * Estan en un contexto porque desde que las administra el backoffice (ADM-10)
 * dejaron de ser una constante: el monto de despacho gratis se anuncia en la
 * cabecera, en la portada, en la ficha, en el carro y en el checkout, y si cada
 * uno lo tuviera escrito, cambiarlo en el panel arreglaria una pantalla y
 * dejaria mintiendo a las otras cuatro.
 *
 * Esta separado del proveedor por lo mismo que los otros dos contextos: el
 * recargado en caliente de Vite necesita que un archivo exporte solo
 * componentes.
 */
import { createContext, useContext } from 'react';

import type { OpcionesDespacho } from '@elcarpintero/compartido';

export interface ValorDespacho {
  /** `null` mientras se cargan, o si la peticion fallo. */
  opciones: OpcionesDespacho | null;
}

export const ContextoDespacho = createContext<ValorDespacho>({ opciones: null });

/**
 * No exige proveedor: fuera de la tienda (el backoffice) devuelve `null` y quien
 * lo usa ya sabe dibujar ese caso, que es el mismo que "todavia no cargo".
 */
export function useDespacho(): ValorDespacho {
  return useContext(ContextoDespacho);
}
